module.exports = __webpack_public_path__ + "img/wemail.4fe32d7d.svg";